module.exports = __webpack_public_path__ + "static/media/DroneBlueMap.4a45494f.svg";